import img1 from '../assets/images/empoweringdoctors-1.jpg';
import img2 from '../assets/images/empoweringdoctor-2.jpg';
import doctorAvatar1 from '../assets/images/docter-profile.png';

export const videoCards = [
  {
    id: 1,
    thumbnail: img2,
    duration: '20Min',
    date: '20/12/2025',
    title: 'Advanced Cardiac Life Support – 2024',
    description: 'Attended cardiology update workshop on heart failure management, 2024',
    authorAvatar: doctorAvatar1,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
  },
  {
    id: 2,
    thumbnail: img1,
    duration: '20Min',
    date: '20/12/2025',
    title: 'Advanced Cardiac Life Support – 2024',
    description: 'Attended cardiology update workshop on heart failure management, 2024',
    authorAvatar: doctorAvatar1,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: false,
  },
  {
    id: 3,
    thumbnail: img2,
    duration: '20Min',
    date: '20/12/2025',
    title: 'Advanced Cardiac Life Support – 2024',
    description: 'Attended cardiology update workshop on heart failure management, 2024',
    authorAvatar: doctorAvatar1,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
  },
  {
    id: 4,
    thumbnail: img1,
    duration: '20Min',
    date: '20/12/2025',
    title: 'Advanced Cardiac Life Support – 2024',
    description: 'Attended cardiology update workshop on heart failure management, 2024',
    authorAvatar: doctorAvatar1,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
  },
];
